import * as React from 'react';
import * as s from './Button.module.scss';
import { DynamicLink } from '../../shared/components';

interface Props {
  href?: string;
  onClick?: () => void;
  slim?: boolean;
  small?: boolean;
  wide?: boolean;
  dark?: boolean;
  filled?: boolean;
  noBorder?: boolean;
  underlined?: boolean;
  black?: boolean;
  notFixedWidth?: boolean;
  className?: string;
  type?: any;
  p0?: boolean;
  fontRegular?: boolean;
  isExternalUrl?: boolean;
}

class Button extends React.Component<Props> {
  render() {
    const {
      children,
      href,
      onClick,
      slim,
      small,
      dark,
      black,
      filled,
      underlined,
      notFixedWidth,
      p0,
      fontRegular,
      className,
      type,
      isExternalUrl,
    } = this.props;

    const classes = [
      className,
      s.button,
      slim ? s.slim : null,
      small ? s.small : null,
      dark ? s.dark : null,
      black ? s.black : null,
      filled ? s.filled : null,
      underlined ? s.underlined : null,
      notFixedWidth ? s.notFixedWidth : null,
      p0 ? s.p0 : null,
      fontRegular ? s.fontRegular : null,
    ].join(' ');

    if (onClick) {
      return (
        <button className={classes} onClick={onClick} type={type}>
          <div className={s.text}>{children}</div>
        </button>
      );
    }

    if (isExternalUrl) {
      return (
        <a className={classes} href={href} target="_blank">
          <div className={s.text}>{children}</div>
        </a>
      );
    }

    return (
      <DynamicLink className={classes} to={href}>
        <div className={s.text}>{children}</div>
      </DynamicLink>
    );
  }
}

export default Button;
